// generated from 158_654 samples

import { z } from "zod";
import { triggerFiltersGetSchema } from "./triggerFiltersGetSchema";

export const performedCustomEventTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PerformedCustomEvent"),
  // null: 72_062 (45.42%)
  // true 762 (0.88%), false 85_830 (99.12%)
  blocklisted: z.boolean().nullable().optional(),
  // null: 224 (0.14%)
  custom_event_name: z.string().nullable(),
  // undefined: 105_597 (66.56%), defined 53_057 (33.44%)
  filter_description: z.string().optional(),
  // undefined: 105_597 (66.56%), defined 53_057 (33.44%)
  filters: triggerFiltersGetSchema.optional(),
  // null: 72_062 (45.42%)
  // true 92 (0.11%), false 86_500 (99.89%)
  hard_deleted: z.boolean().nullable().optional(),
});
